/* eslint-disable */
import React, { useEffect, useState } from "react";

interface BannerGeneralComponentProps {
  banner: any;
}

const BannerGeneralComponent: React.FC<BannerGeneralComponentProps> = ({ banner }) => {
  const [isPortrait, setIsPortrait] = useState<boolean>(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(orientation: portrait)");

    // Función para actualizar el estado
    const handleOrientationChange = (e: MediaQueryListEvent | MediaQueryList) => {
      setIsPortrait(e.matches);
    };

    // Configurar el estado inicial
    handleOrientationChange(mediaQuery);

    // Escuchar cambios en la orientación
    mediaQuery.addEventListener("change", handleOrientationChange);

    // Limpieza
    return () => {
      mediaQuery.removeEventListener("change", handleOrientationChange);
    };
  }, []);

  const backgroundUrl = isPortrait
    ? `https://manager.hyundaicolombia.co/${banner?.media_portrait?.url}`
    : `https://manager.hyundaicolombia.co/${banner?.media?.url}`;

  return (
    <div
      className="banner-posventa-component"
      style={{ backgroundImage: `url(${backgroundUrl})` }}
    >
      <div className={`text1-banner-posventa-component`}>{banner?.title}</div>
    </div>
  );
};

export default BannerGeneralComponent;
